enum AssetDocumentFieldNames {
  Documents = 'documents',
  Document = 'attachmentAttached',
  Name = 'name',
  Tags = 'documentationTags',
}

export default AssetDocumentFieldNames;
